import { render, staticRenderFns } from "./reportSingle.vue?vue&type=template&id=1bb722fc&"
import script from "./reportSingle.vue?vue&type=script&lang=js&"
export * from "./reportSingle.vue?vue&type=script&lang=js&"
import style0 from "./reportSingle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports